"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSourceImageContainer = void 0;
exports.ValueSourceSelector = ValueSourceSelector;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const property_1 = require("@genesys/property");
const Images = __importStar(require("../images"));
const elements_1 = require("./elements");
const dropdown_1 = require("./dropdown");
exports.ValueSourceImageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: left;
  height: 24px;
`;
const autoImage = Images.ValueSources.auto;
const userImage = Images.ValueSources.user;
function ValueSourceSelector({ isLocked, onChange, propertyName, selectedProperties, showCodes, valueSources }) {
    if (valueSources.length === 0) {
        return (React.createElement(exports.ValueSourceImageContainer, null,
            React.createElement(elements_1.ValueSourceImage, { src: userImage }),
            React.createElement("span", null,
                " ",
                showCodes && `(null)`)));
    }
    if (valueSources.length === 1 || isLocked) {
        const valueSource = valueSources[0];
        const effectiveImage = valueSource.propertyValueSourceId === "User" ? userImage : autoImage;
        return (React.createElement(exports.ValueSourceImageContainer, null,
            React.createElement(elements_1.ValueSourceImage, { src: effectiveImage }),
            React.createElement("span", null,
                " ",
                showCodes && `(${valueSource.value})`)));
    }
    const options = valueSources.map(v => ({
        label: "",
        imageUrl: v.propertyValueSourceId === "User" ? userImage : autoImage,
        isItemValid: true,
        value: v.value.toString()
    }));
    const sourceInt = property_1.PropertyValueSet.getInteger(`source_${propertyName}`, selectedProperties);
    const value = (sourceInt && sourceInt.toString()) || valueSources[0].value.toString();
    return (React.createElement(dropdown_1.ValueSourceDropdown, { onChange: (newValue) => {
            onChange(property_1.PropertyValueSet.setInteger(`source_${propertyName}`, parseInt(newValue, 10), selectedProperties), `source_${propertyName}`);
        }, options: options, selected: value, showCodes: showCodes }));
}
//# sourceMappingURL=value-source-selector.js.map